import React from "react";
import PropTypes from "prop-types";
import Modal from "../Modal";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  question = "Are you sure?",
}) => {
  return (
    <Modal isOpen={isOpen}>
      <div className="flex flex-col items-center justify-center p-4 lg:h-[30vh] lg:p-8 xl:p-12">
        <h2 className="mb-2 block text-center text-xs font-bold text-black md:text-sm lg:mb-4 lg:text-base xl:mb-6 xl:text-lg 2xl:mb-10 2xl:text-2xl">
          {question}
        </h2>
        <div className="flex w-full justify-center">
          <button
            onClick={onClose}
            className="rounded-md border border-transparent bg-errorColor px-2 py-1 text-center text-xs text-white shadow-md transition-all hover:bg-hoverColor hover:shadow-lg active:bg-hoverColor active:shadow-none md:text-sm lg:px-4 lg:py-2 lg:text-base xl:text-xl"
            autoFocus={false}
          >
            No
          </button>
          <button
            onClick={onConfirm}
            className="ml-6 rounded-md border border-transparent bg-successColor px-2 py-1 text-center text-xs text-white shadow-md transition-all hover:bg-hoverColor hover:shadow-lg focus:bg-hoverColor focus:shadow-none active:bg-hoverColor active:shadow-none md:text-sm lg:ml-12 lg:px-4 lg:py-2 lg:text-base xl:ml-16 xl:text-xl"
          >
            Yes
          </button>
        </div>
      </div>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  question: PropTypes.string,
};

export default ConfirmationModal;
